import { render, staticRenderFns } from "./EmptyAlertBehaviorEditor.vue?vue&type=template&id=4c91d022&"
import script from "./EmptyAlertBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./EmptyAlertBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports